import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

type Props = {
  por: string | null;
  prancha: string | null;
  revisao: string | null;
  disciplina: string | null;
  onPorChange: (v: string ) => void;
  onPranchaChange: (v: string ) => void;
  onRevisaoChange: (v: string ) => void;
  onDisciplinaChange: (v: string ) => void;
  onClear: () => void;
};

export const HeaderDisciplina = ({
  por,
  prancha,
  revisao,
  disciplina,
  onPorChange,
  onPranchaChange,
  onRevisaoChange,
  onDisciplinaChange,
  onClear,
}: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2">
          {/* LINHA 1 */}
          <FormControl size="small" fullWidth>
            <InputLabel id="modulo-dashboard">Por</InputLabel>
            <Select labelId="modulo-dashboard" label="Por" value={por ?? ""} onChange={(e) => onPorChange?.(e.target.value)}>
              <MenuItem value={"T"}>Todos</MenuItem>
              <MenuItem value={"D"}>Disciplina</MenuItem>
              <MenuItem value={"S"}>Subdisciplina</MenuItem>
            </Select>
          </FormControl>

          <DefaultInput label="Disciplina / Subdisciplina" name="disciplina" value={disciplina ?? ""} onChangeValue={onDisciplinaChange} />

          {/* LINHA 2 */}
          <DefaultInput label="Prancha" name="prancha" value={prancha ?? ""} onChangeValue={onPranchaChange} />

          <DefaultInput label="Revisão" name="revisao" value={revisao ?? ""} onChangeValue={onRevisaoChange} />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClear}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
